(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pin-pina-launcher"] && !Shopify.designMode) return;
  try {
    const root = document.querySelector('[data-pina-chat]');
  if (root && root.dataset.ready !== 'true') {
    root.dataset.ready = 'true';
    const panel = root.querySelector('.pin-chat__panel');
    const launcher = root.querySelector('[data-pina-toggle]');
    const form = root.querySelector('[data-pina-assistant]');
    const field = form.querySelector('[name="message"]');
    const button = form.querySelector('button[type="submit"]');
    const status = form.querySelector('[role="status"]');
    const thinking = form.querySelector('.pin-pina__thinking');
    const log = root.querySelector('[role="log"]');
    const scroll = root.querySelector('.pin-chat__scroll');
    const errorBox = root.querySelector('.pin-chat__error');
    const prompts = root.querySelector('.pin-chat__prompts');
    const approvedDestinations = new Set(["https://pinopoles.com/","https://pinopoles.com/pages/our-services","https://pinopoles.com/pages/decor-a-la-carte","https://pinopoles.com/pages/gallery","https://pinopoles.com/pages/about-us-1","https://pinopoles.com/pages/faq","https://pinopoles.com/pages/contact","https://pinopoles.com/policies/privacy-policy","https://pinopoles.com/policies/refund-policy","https://pinopoles.com/policies/shipping-policy","https://pinopoles.com/policies/terms-of-service","https://pinopoles.com/policies/legal-notice"]);
    let pending = false;
    let returnFocus = launcher;
    let lastQuestion = '';
    let retryTurn = null;
    const setOpen = (open, opener = launcher) => {
      panel.hidden = !open;
      root.dataset.open = String(open);
      launcher.setAttribute('aria-expanded', String(open));
      if (open) { returnFocus = opener; field.focus({ preventScroll: true }); }
      else if (panel.contains(document.activeElement)) returnFocus.focus({ preventScroll: true });
    };
    launcher.addEventListener('click', () => setOpen(panel.hidden));
    root.querySelector('[data-pina-close]').addEventListener('click', () => setOpen(false));
    root.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !panel.hidden) { event.preventDefault(); event.stopPropagation(); setOpen(false); }
    });
    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-pina-open]');
      if (opener) { event.preventDefault(); setOpen(true, opener); }
    });
    document.querySelectorAll('[data-pina-open]').forEach((item) => { item.hidden = false; });
    root.hidden = false;
    const setPending = (value) => {
      pending = value;
      button.disabled = value;
      field.readOnly = value;
      prompts.querySelectorAll('button').forEach((item) => { item.disabled = value; });
      log.setAttribute('aria-busy', String(value));
      thinking.hidden = !value;
      status.textContent = value ? form.dataset.loadingStatus : '';
    };
    const appendMessage = (turn, text, user = false) => {
      const message = document.createElement('div');
      message.className = 'pin-chat__message' + (user ? ' pin-chat__message--user' : '');
      const speaker = document.createElement('span');
      speaker.className = 'pin-chat__speaker';
      speaker.textContent = user ? form.dataset.you : form.dataset.speaker;
      message.append(speaker, document.createTextNode(text));
      turn.append(message);
      return message;
    };
    const renderLinks = (answer, links) => {
      if (!Array.isArray(links)) return;
      const list = document.createElement('div');
      list.className = 'pin-pina__links';
      const seen = new Set();
      links.slice(0, 3).forEach((link) => {
        if (!link || !approvedDestinations.has(link.url) || seen.has(link.url)
            || typeof link.label !== 'string' || !link.label.trim() || link.label.length > 80) return;
        seen.add(link.url);
        const anchor = document.createElement('a');
        anchor.href = link.url;
        anchor.textContent = link.label;
        list.append(anchor);
      });
      if (list.childElementCount) answer.append(list);
    };
    const submitQuestion = async (question, existingTurn = null) => {
      if (pending || !question || question.length > 800) return;
      lastQuestion = question;
      errorBox.hidden = true;
      prompts.hidden = true;
      root.querySelector('.pin-chat__welcome').hidden = true;
      const turn = existingTurn || document.createElement('div');
      if (!existingTurn) { turn.className = 'pin-chat__turn'; appendMessage(turn, question, true); log.append(turn); }
      while (log.children.length > 10) log.firstElementChild.remove();
      retryTurn = turn;
      setPending(true);
      scroll.scrollTop = scroll.scrollHeight;
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 45000);
      try {
        const response = await fetch('https://pina.pinopoles.com/customer/assist', {
          method: 'POST', mode: 'cors', credentials: 'include', cache: 'no-store',
          headers: { 'Content-Type': 'application/json' }, signal: controller.signal,
          body: JSON.stringify({ message: question }),
        });
        if (!response.ok) throw new Error('assistance unavailable');
        const result = await response.json();
        if (!['answered', 'escalation_required', 'authentication_required', 'unavailable'].includes(result.status)
            || typeof result.answer !== 'string' || !result.answer.trim() || result.answer.length > 4000) throw new Error('invalid response');
        const answer = appendMessage(turn, result.answer);
        renderLinks(answer, result.links);
        field.value = '';
        retryTurn = null;
        scroll.scrollTop = Math.max(0, answer.offsetTop - scroll.offsetTop - 12);
      } catch (_) {
        errorBox.querySelector('p').textContent = form.dataset.unavailable;
        errorBox.hidden = false;
        status.textContent = form.dataset.unavailable;
      } finally {
        clearTimeout(timeout);
        setPending(false);
        if (!errorBox.hidden) status.textContent = form.dataset.unavailable;
      }
    };
    form.addEventListener('submit', (event) => { event.preventDefault(); submitQuestion(field.value.trim()); });
    prompts.querySelectorAll('[data-pina-prompt]').forEach((item) => item.addEventListener('click', () => {
      if (pending) return;
      field.value = item.textContent.trim();
      form.requestSubmit();
    }));
    root.querySelector('[data-pina-retry]').addEventListener('click', () => submitQuestion(lastQuestion, retryTurn));
    const viewport = window.visualViewport;
    let layoutFrame = 0;
    const position = () => {
      cancelAnimationFrame(layoutFrame);
      layoutFrame = requestAnimationFrame(() => {
        const height = viewport ? viewport.height : window.innerHeight;
        const keyboard = viewport ? Math.max(0, window.innerHeight - height - viewport.offsetTop) : 0;
        root.style.setProperty('--pina-height', height + 'px');
        root.style.setProperty('--pina-width', document.documentElement.clientWidth + 'px');
        root.style.setProperty('--pina-bottom', keyboard + 'px');
        const overlay = document.querySelector('dialog[open], .menu-drawer-container[open], #shopify-pc__banner:not([hidden])');
        root.hidden = Boolean(overlay && overlay.getBoundingClientRect().height > 0);
      });
    };
    viewport?.addEventListener('resize', position);
    viewport?.addEventListener('scroll', position);
    window.addEventListener('resize', position, { passive: true });
    document.addEventListener('theme-drawer:open', position);
    document.addEventListener('theme-drawer:close', position);
    document.addEventListener('toggle', position, true);
    const overlays = new MutationObserver((records) => {
      if (records.some((record) => !root.contains(record.target))) position();
    });
    overlays.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['open', 'hidden'] });
    position();
  }
  } catch(e) { console.error(e); }
})();

})();
